export const wrapperStyles = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '6px',
};

export const iconStyles = {
  cursor: 'pointer',
  color: 'text.secondary',
  display: 'inline-flex',
  alignItems: 'center',
  '&:hover': {
    color: 'text.primary',
  },
};
